<agpr-dialog-container
    [id]="id + '.addSourcesToGroupDialog'"
    heading="Source.addToGroup"
    (close)="cancel()"
>
    <div class='agpr-addSourcesToGroupDialog-content'>
        <agpr-scroll-panel>
            <agpr-autocomplete
                #autocomplete
                [id]="id + '.autoComplete'"
                labelField="name"
                label="SourceGroup"
                placeholder="SourceGroups.selection.add.placeholder"
                [dropdown]="true"
                [(ngModel)]="selectedSourceGroup"
                [suggestions]="sourceGroupList$"
                [customOptions]="sourceGroupAutocompleteOptions"
                [clearOnBlur]="false"
                [multiSelection]="false"
            ></agpr-autocomplete>
            <p class="agpr-addSourcesToGroupDialog-message"> {{ 'Source.addToGroup.confirmMessage' | localize }}</p>
            <ul
                *ngIf="sourceList && sourceList.length > 0"
                class='agpr-list'
            >
                <li
                    *ngFor="let source of sourceList"
                    class='agpr-list-item'
                >
                    <span class="agpr-list-bullet fa fa-circle" aria-hidden="true"></span>
                    {{ source.name }} ({{source.type | lowercase}})
                </li>
            </ul>
        </agpr-scroll-panel>
    </div>
    <ng-template #footerLeft>
        <agpr-button
            [id]="id + '.addSourcesToGroupDialog.cancel'"
            label="cancel"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            [id]="id + '.addSourcesToGroupDialog.ok'"
            [style]="buttonTypes.primary"
            [disabled]="!selectedSourceGroup"
            label="Source.addToGroup.addSources"
            (click)="addSources()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
